/* Douga Douga – motion design, incentives & commande express (2026) */
(() => {
  'use strict';
  const doc = document.documentElement;
  doc.classList.add('dd-js');
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(pointer: fine)').matches;
  const CFG = window.DD_GIFT || null;
  const SH = window.Shopify || {};
  const RATE = (SH.currency && parseFloat(SH.currency.rate)) || 1;
  const CUR = (SH.currency && SH.currency.active) || 'EUR';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const MF = CFG && CFG.moneyFormat && (!CFG.shopCurrency || CFG.shopCurrency === CUR) ? CFG.moneyFormat : null;
  const grp = (s, th, dec) => { const [i, d] = s.split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? dec + d : ''); };
  const fmt = (c) => {
    const v = Math.round(c), n2 = (v / 100).toFixed(2), n0 = String(Math.round(v / 100));
    if (MF) {
      const map = { amount: grp(n2, ',', '.'), amount_no_decimals: grp(n0, ',', ''), amount_with_comma_separator: grp(n2, '.', ','), amount_no_decimals_with_comma_separator: grp(n0, '.', ''), amount_with_space_separator: grp(n2, ' ', ','), amount_with_apostrophe_separator: grp(n2, "'", '.') };
      return MF.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => map[k] || map.amount_with_comma_separator).replace(/<[^>]*>/g, '');
    }
    return (v / 100).toLocaleString('fr-FR', { style: 'currency', currency: CUR });
  };
  const vib = (n = 8) => { try { navigator.vibrate && navigator.vibrate(n); } catch (e) {} };
  const ICON = {
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18M12 8c-2-4-6-4-6-1.5S9 8 12 8zm0 0c2-4 6-4 6-1.5S15 8 12 8z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 7"/></svg>'
  };

  /* ---------- utilitaires ---------- */
  function rollNumber(el, to, dur = 650) {
    if (!el) return;
    const from = parseFloat(el.dataset.v || '0');
    el.dataset.v = to;
    if (RM || from === to) { el.textContent = fmt(to); return; }
    const t0 = performance.now();
    const step = (t) => {
      const k = Math.min(1, (t - t0) / dur);
      const e = 1 - Math.pow(1 - k, 4);
      el.textContent = fmt(from + (to - from) * e);
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  function bump(el) {
    if (!el) return;
    el.classList.remove('is-bump', 'dd-bump');
    void el.offsetWidth;
    el.classList.add(el.id === 'cart-icon-bubble' ? 'dd-bump' : 'is-bump');
  }
  function toast(html, ms = 2600) {
    const t = document.createElement('div');
    t.className = 'dd-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = '<i>' + ICON.gift + '</i><span>' + html + '</span>';
    document.body.appendChild(t);
    requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('show')));
    setTimeout(() => { t.classList.remove('show'); setTimeout(() => t.remove(), 700); }, ms);
  }
  function confetti(x, y) {
    if (RM) return;
    const c = document.createElement('canvas');
    c.className = 'dd-confetti';
    document.body.appendChild(c);
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    c.width = innerWidth * dpr; c.height = innerHeight * dpr;
    const g = c.getContext('2d');
    g.scale(dpr, dpr);
    const cols = ['#F3D27A', '#C8A13A', '#2F5D50', '#8DB596', '#FBF7EE', '#1E2A26'];
    const P = Array.from({ length: 120 }, () => {
      const a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.3;
      const s = 6 + Math.random() * 10;
      return { x, y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, r: Math.random() * 6, vr: (Math.random() - 0.5) * 0.35, w: 5 + Math.random() * 7, h: 3 + Math.random() * 5, c: cols[(Math.random() * cols.length) | 0], o: Math.random() < 0.4 };
    });
    const t0 = performance.now();
    const f = (t) => {
      const k = (t - t0) / 1000;
      g.clearRect(0, 0, innerWidth, innerHeight);
      P.forEach((p) => {
        p.vy += 0.34; p.vx *= 0.986; p.vy *= 0.986; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        g.save(); g.globalAlpha = Math.max(0, 1 - k / 2); g.translate(p.x, p.y); g.rotate(p.r); g.fillStyle = p.c;
        if (p.o) { g.beginPath(); g.ellipse(0, 0, p.w * 0.55, p.h * 0.95, 0, 0, Math.PI * 2); g.fill(); }
        else g.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        g.restore();
      });
      if (k < 2.1) requestAnimationFrame(f); else c.remove();
    };
    requestAnimationFrame(f);
  }
  let lastCeleb = 0;
  function celebrate(el, msg) {
    if (Date.now() - lastCeleb < 5000) return;
    lastCeleb = Date.now();
    const r = el ? el.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight / 2, width: 0, height: 0 };
    confetti(r.left + r.width / 2, r.top + r.height / 2);
    vib([12, 40, 18]);
    if (msg) toast(msg);
  }
  function cartIcon() { return document.getElementById('cart-icon-bubble'); }
  function fly(src) {
    const to = cartIcon();
    if (!src || !to || RM) return Promise.resolve();
    const a = src.getBoundingClientRect(), b = to.getBoundingClientRect();
    if (!a.width || a.bottom < 0 || a.top > innerHeight) { bump(to); return Promise.resolve(); }
    const s = Math.min(a.width, a.height, 150);
    const n = document.createElement('img');
    n.src = src.currentSrc || src.src;
    n.className = 'dd-fly';
    n.alt = '';
    Object.assign(n.style, { left: a.left + a.width / 2 - s / 2 + 'px', top: a.top + a.height / 2 - s / 2 + 'px', width: s + 'px', height: s + 'px' });
    document.body.appendChild(n);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = n.animate([
      { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
      { transform: `translate(${dx * 0.45}px,${dy * 0.45 - 110}px) scale(.62) rotate(-8deg)`, opacity: 1, offset: 0.5 },
      { transform: `translate(${dx}px,${dy}px) scale(.12) rotate(8deg)`, opacity: 0.3 }
    ], { duration: 900, easing: 'cubic-bezier(.55,0,.25,1)' });
    return anim.finished.then(() => { n.remove(); bump(to); vib(10); }).catch(() => n.remove());
  }

  /* ---------- panier & offre cadeau ---------- */
  let cartCache = null;
  async function getCart(force) {
    if (cartCache && !force) return cartCache;
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    cartCache = await r.json();
    return cartCache;
  }
  const isElig = (pid) => !!CFG && CFG.eligible.indexOf(Number(pid)) > -1;
  function giftState(cart, extra) {
    if (!CFG) return null;
    const T = Math.round(CFG.threshold * RATE);
    let elig = 0, giftIn = 0, giftUnit = 0;
    (cart ? cart.items : []).forEach((i) => {
      if (i.selling_plan_allocation) return; // l'abonnement ne compte pas pour la gourde offerte
      if (i.variant_id === CFG.gift) { giftIn += i.quantity; giftUnit = i.original_price; }
      if (isElig(i.product_id)) elig += i.original_line_price;
    });
    if (giftIn > 0) elig -= giftUnit;
    (extra || []).forEach((x) => { if (isElig(x.pid)) elig += x.price * x.qty; });
    elig = Math.max(0, elig);
    return { T, elig, giftIn, left: Math.max(0, T - elig), p: Math.min(1, elig / T), ok: elig >= T };
  }
  function addItems(items, withSections) {
    const body = { items };
    if (withSections) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then((r) => r.json().then((j) => { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Erreur'); return j; }))
      .then((j) => { cartCache = null; return j; });
  }
  function openDrawer(resp) {
    const d = document.querySelector('cart-drawer');
    if (d && resp && resp.sections && typeof d.renderContents === 'function') {
      d.classList.remove('is-empty');
      d.renderContents(resp);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dd', cartData: resp });
      return true;
    }
    return false;
  }

  /* barre de progression cadeau (réutilisable) */
  const memGet = (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
  const memSet = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} };
  function GiftBar(host, opts = {}) {
    let prevOk = opts.key ? memGet(opts.key) : null;
    const el = document.createElement('div');
    el.className = 'dd-gb' + (opts.dark ? ' dd-gb--dark' : '') + (opts.cls ? ' ' + opts.cls : '');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<div class="dd-gb__row"><span class="dd-gb__ic">' + ICON.gift + '</span><p class="dd-gb__msg"></p></div>' +
      '<div class="dd-gb__track"><span class="dd-gb__fill"></span><span class="dd-gb__knob"></span></div>' +
      '<div class="dd-gb__meta"><span class="ok">' + ICON.check + ' Livraison point relais offerte</span><span class="dd-gb__th"></span></div>' +
      (opts.canAdd ? '<button type="button" class="dd-gb__cta">' + ICON.gift.replace('<svg', '<svg width="16" height="16"') + ' Ajouter ma gourde offerte</button>' : '') +
      (opts.suggest ? '<div class="dd-gb__sug" hidden></div>' : '');
    if (opts.before) host.parentNode.insertBefore(el, host); else if (opts.after) host.after(el); else host.prepend(el);
    if (opts.startP != null) el.style.setProperty('--p', opts.startP);
    const msg = el.querySelector('.dd-gb__msg');
    const sugEl = el.querySelector('.dd-gb__sug');
    // suggestion : le produit éligible le moins cher qui fait atteindre le seuil
    function paintSug(st) {
      if (!sugEl) return;
      const list = (CFG.suggest || []).filter((x) => x && x.pid !== CFG.giftProduct);
      if (!st || st.ok || !list.length) { sugEl.hidden = true; return; }
      const inCart = ((lastCart && lastCart.items) || []).map((i) => i.variant_id);
      let pool = list.filter((x) => inCart.indexOf(x.v) < 0);
      if (!pool.length) pool = list;
      const reachers = pool.filter((x) => x.p >= st.left).sort((a, b) => a.p - b.p);
      const pick = reachers[0] || pool.slice().sort((a, b) => b.p - a.p)[0];
      const reach = pick.p >= st.left;
      sugEl.hidden = false;
      sugEl.innerHTML = (pick.img ? '<img src="' + pick.img + '" alt="" width="44" height="44">' : '') +
        '<p>Ajoutez <b>' + pick.t + '</b> (' + fmt(pick.p) + ')' + (reach ? ' et la gourde est <b>offerte</b>' : ' pour vous rapprocher de la gourde offerte') + '</p>' +
        '<button type="button" data-v="' + pick.v + '" data-pid="' + pick.pid + '" data-p="' + pick.p + '">+ Ajouter</button>';
    }
    if (sugEl) sugEl.addEventListener('click', async (e) => {
      const b = e.target.closest('button'); if (!b) return;
      b.classList.add('is-loading');
      const items = [{ id: Number(b.dataset.v), quantity: 1 }];
      const st2 = giftState(lastCart, [{ pid: Number(b.dataset.pid), price: Number(b.dataset.p), qty: 1 }]);
      const withG = st2 && st2.ok && !st2.giftIn;
      if (withG) items.push({ id: CFG.gift, quantity: 1 });
      try {
        let resp;
        try { resp = await addItems(items, true); }
        catch (err) { if (!withG) throw err; items.pop(); resp = await addItems(items, true); }
        if (withG && items.length > 1) memSet('ddGiftAuto', '1');
        if (opts.onAdded) opts.onAdded(resp); else if (!openDrawer(resp)) location.reload();
      } catch (err) { toast(err.message || 'Une erreur est survenue'); }
      b.classList.remove('is-loading');
    });
    const api = {
      el,
      update(st) {
        if (!st) { el.hidden = true; return; }
        const name = CFG.giftName || 'gourde 50 cl';
        const val = CFG.giftPrice ? ' (valeur ' + fmt(CFG.giftPrice) + ')' : '';
        el.querySelector('.dd-gb__th').textContent = 'Offerte dès ' + fmt(st.T);
        if (st.ok) msg.innerHTML = st.giftIn ? '<b>C’est offert !</b> Votre ' + name + ' est gratuite' + val + ', la remise s’applique au paiement.' : '<b>Bravo !</b> Votre ' + name + ' est offerte' + val + '.' + (opts.canAdd ? ' Ajoutez-la en un clic.' : '');
        else if (st.elig <= 0) msg.innerHTML = 'Dès <b>' + fmt(st.T) + '</b> d’achat, une <b>' + name + '</b> vous est offerte' + val + '.';
        else msg.innerHTML = 'Plus que <b>' + fmt(st.left) + '</b> pour recevoir votre <b>' + name + '</b> offerte' + val + '.';
        paintSug(st);
        requestAnimationFrame(() => el.style.setProperty('--p', st.p.toFixed(4)));
        el.classList.toggle('is-ok', st.ok);
        el.classList.toggle('can-add', st.ok && !st.giftIn);
        const k = st.ok ? '1' : '0';
        if (opts.celebrate !== false && st.ok && prevOk === '0') setTimeout(() => celebrate(el.querySelector('.dd-gb__ic'), 'Gourde de 50 cl d’huile offerte débloquée'), 350);
        prevOk = k;
        if (opts.key) memSet(opts.key, k);
        api.p = st.p;
      },
      p: opts.startP || 0
    };
    const cta = el.querySelector('.dd-gb__cta');
    if (cta) cta.addEventListener('click', async () => {
      cta.classList.add('is-loading');
      try {
        const resp = await addItems([{ id: CFG.gift, quantity: 1 }], true);
        if (opts.onAdded) opts.onAdded(resp); else if (!openDrawer(resp)) location.reload();
      } catch (e) { toast(e.message || 'Impossible d’ajouter la gourde'); }
      cta.classList.remove('is-loading');
    });
    return api;
  }

  /* tiroir panier + page panier */
  let drawerP = 0, lastCart = null;
  async function refreshCartBars(force) {
    if (!CFG) return;
    const cart = await getCart(force).catch(() => null);
    if (!cart) return;
    lastCart = cart;
    const st = giftState(cart);
    // tiroir
    const dr = document.querySelector('cart-drawer');
    if (dr && cart.item_count > 0) {
      const head = $('#CartDrawer .drawer__header', dr);
      let bar = $('.dd-gb', dr);
      if (head && !bar) {
        const g = GiftBar(head, { after: true, canAdd: true, suggest: true, startP: drawerP, key: 'ddGiftOk' });
        g.el._dd = g;
        bar = g.el;
      }
      if (bar && bar._dd) { bar._dd.update(st); drawerP = st.p; }
    }
    // page panier
    const items = document.getElementById('main-cart-items');
    if (items && cart.item_count > 0) {
      let pb = document.querySelector('.dd-gb--page');
      if (!pb) { const g = GiftBar(items, { before: true, canAdd: true, suggest: true, cls: 'dd-gb--page', key: 'ddGiftOk', onAdded: () => location.reload() }); g.el._dd = g; pb = g.el; }
      pb._dd.update(st);
    } else if (items) { const pb = document.querySelector('.dd-gb--page'); if (pb) pb.remove(); }
  }
  function watchDrawer() {
    const dr = document.querySelector('cart-drawer');
    if (!dr) return;
    let t;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => { if (!$('.dd-gb', dr) && $('#CartDrawer .drawer__header', dr)) refreshCartBars(true); }, 120);
    }).observe(dr, { childList: true, subtree: true });
  }

  /* ---------- révélations ---------- */
  function reveal() {
    const sel = ['.dd-section .dd-kicker', '.dd-section h2', '.dd-usp__item', '.dd-story__media', '.dd-story__text', '.dd-story__stats > div', '.dd-pro__box', '.dd-pro__list li', '.dd-insta__chips li', '.dd-insta__card', '.dd-video__frame', '.dd-video__lead', '.dd-oc', '.dd-order__lead'].join(',');
    const els = $$(sel).filter((e) => !e.closest('.dd-hero, .ddpro'));
    if (RM || !('IntersectionObserver' in window)) return;
    els.forEach((e) => {
      e.classList.add('dd-r');
      const sibs = Array.from(e.parentElement.children).filter((x) => x.matches(sel));
      e.style.setProperty('--dd-i', Math.min(sibs.indexOf(e), 8));
    });
    const io = new IntersectionObserver((es) => es.forEach((en) => {
      if (!en.isIntersecting) return;
      const t = en.target;
      t.classList.add('dd-in');
      io.unobserve(t);
      const i = parseInt(t.style.getPropertyValue('--dd-i') || '0', 10);
      setTimeout(() => { t.classList.remove('dd-r', 'dd-in'); t.style.removeProperty('--dd-i'); }, 1700 + i * 80);
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- bannière ---------- */
  function hero() {
    const h = $('.dd-hero--home');
    if (!h) return;
    const t = $('.dd-hero__title', h);
    if (t && !RM && !t.dataset.split) {
      t.dataset.split = '1';
      let wi = 0;
      const splitText = (txt) => {
        const frag = document.createDocumentFragment();
        txt.split(/(\s+)/).forEach((w) => {
          if (!w) return;
          if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(' ')); return; }
          const o = document.createElement('span'); o.className = 'dd-w';
          const i = document.createElement('span'); i.textContent = w; i.style.setProperty('--wi', wi++);
          o.appendChild(i); frag.appendChild(o);
        });
        return frag;
      };
      Array.from(t.childNodes).forEach((n) => {
        if (n.nodeType === 3) t.replaceChild(splitText(n.textContent), n);
        else if (n.nodeType === 1) { const txt = n.textContent; n.textContent = ''; n.appendChild(splitText(txt)); }
      });
    }
    $$('.dd-hero__perks li', h).forEach((li, i) => li.style.setProperty('--pi', i));
    requestAnimationFrame(() => requestAnimationFrame(() => h.classList.add('dd-hero--ready')));
    const par = $('.dd-par', h);
    if (par && !RM) {
      let ticking = false;
      addEventListener('scroll', () => {
        if (ticking) return; ticking = true;
        requestAnimationFrame(() => {
          const r = h.getBoundingClientRect();
          if (r.bottom > 0) par.style.transform = 'translate3d(0,' + Math.max(-40, Math.min(40, -r.top * 0.08)).toFixed(1) + 'px,0)';
          ticking = false;
        });
      }, { passive: true });
    }
  }

  /* ---------- bandeau défilant réactif au scroll ---------- */
  function marquees() {
    const tracks = $$('.dd-mq__track');
    if (!tracks.length || RM) return;
    let last = scrollY, vel = 0, raf;
    const anims = () => tracks.map((t) => t.getAnimations && t.getAnimations()[0]).filter(Boolean);
    const loop = () => {
      vel *= 0.92;
      anims().forEach((a) => { a.playbackRate = 1 + Math.min(4, vel / 14); });
      raf = vel > 0.2 ? requestAnimationFrame(loop) : null;
    };
    addEventListener('scroll', () => {
      vel = Math.min(60, vel + Math.abs(scrollY - last)); last = scrollY;
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
  }

  /* ---------- magnétisme ---------- */
  function magnetic() {
    if (!FINE || RM) return;
    $$('.dd-btn, .dd-cartp__go, .dd-hero__seal').forEach((b) => {
      b.classList.add('dd-mag');
      b.addEventListener('mousemove', (e) => {
        const r = b.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) / r.width, y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 10).toFixed(1) + 'px,' + (y * 8).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', () => { b.style.transform = ''; });
    });
  }

  /* ---------- compteurs ---------- */
  function counters() {
    const els = $$('.dd-story__stats b');
    if (!els.length || RM || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((es) => es.forEach((en) => {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      const el = en.target, m = el.textContent.match(/^([^\d]*)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m) return;
      const end = parseFloat(m[2].replace(',', '.')), t0 = performance.now(), d = 1400;
      const f = (t) => { const k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3); el.textContent = m[1] + Math.round(end * e) + m[3]; if (k < 1) requestAnimationFrame(f); };
      requestAnimationFrame(f);
    }), { threshold: 0.6 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- ajout au panier (fiches produit Dawn) ---------- */
  function hookProductForms() {
    document.addEventListener('submit', (e) => {
      const f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || f.closest('.dd-order')) return;
      const scope = f.closest('.product, .card-wrapper, quick-add-modal, section') || document;
      const img = $('.product__media-item.is-active img, .product__media img, .card__media img, img', scope);
      fly(img);
    }, true);
  }

  /* ---------- module « Composez votre panier » (cartes façon Espace Pro, ajout direct au panier) ---------- */
  function cartReq(url, body) {
    body.sections = 'cart-drawer,cart-icon-bubble';
    body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then((r) => r.json().then((j) => { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Erreur'); return j; }))
      .then((j) => { cartCache = null; return j; });
  }
  /* met à jour le tiroir et la pastille du panier sans ouvrir le tiroir */
  function silentRender(resp, count) {
    if (!resp || !resp.sections) return;
    const inner = (html, sel) => { if (!html) return null; const d = new DOMParser().parseFromString(html, 'text/html'); const el = d.querySelector(sel); return el ? el.innerHTML : null; };
    const dr = document.querySelector('cart-drawer');
    const list = dr && typeof dr.getSectionsToRender === 'function' ? dr.getSectionsToRender() : [{ id: 'cart-icon-bubble' }];
    list.forEach((s) => {
      const el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      const h = inner(resp.sections[s.id], s.selector || '.shopify-section');
      if (el && h != null) el.innerHTML = h;
    });
    if (dr) {
      const ov = dr.querySelector('#CartDrawer-Overlay');
      if (ov && typeof dr.close === 'function') ov.addEventListener('click', dr.close.bind(dr));
      if (count != null) dr.classList.toggle('is-empty', count === 0);
    }
  }
  function openCart() {
    const dr = document.querySelector('cart-drawer');
    if (dr && typeof dr.open === 'function' && !dr.classList.contains('is-empty')) { dr.open(); return true; }
    location.href = '/cart';
    return false;
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('[data-dd-open]');
    if (!a) return;
    e.preventDefault();
    openCart();
  });

  function orderModule(root) {
    const cards = $$('.dd-oc', root);
    const data = [];
    const byPid = {};
    cards.forEach((c) => { const d = $('script[data-p]', c); if (!d) return; try { const p = JSON.parse(d.textContent); data.push(p); byPid[p.pid] = p; } catch (e) {} });
    if (!data.length) return;
    const chosen = {}; // pid -> vid
    const mode = {}; // pid -> 'one' | 'sub'
    let cart = { items: [], item_count: 0, total_price: 0 };
    let opened = false;
    let queue = Promise.resolve();

    const cur = (c) => {
      const p = byPid[c.dataset.pid];
      const vid = chosen[p.pid] || (p.vars.find((v) => v.av) || p.vars[0]).id;
      const v = p.vars.find((x) => x.id === vid) || p.vars[0];
      const md = mode[p.pid] === 'sub' && v.sp ? 'sub' : 'one';
      return { p, v, md };
    };
    const unit = (v, md) => (md === 'sub' ? v.spp : v.price);
    const arts = (n) => n + (n > 1 ? ' articles' : ' article');
    const isLine = (it, v, md) => it.variant_id === v.id && (md === 'sub' ? !!(it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id === v.sp) : !it.selling_plan_allocation);
    const autoGift = () => memGet('ddGiftAuto') === '1';
    function qOf(v, md) {
      let q = (cart.items || []).reduce((s, it) => s + (isLine(it, v, md) ? it.quantity : 0), 0);
      if (CFG && md === 'one' && v.id === CFG.gift && autoGift()) q = Math.max(0, q - 1); // la gourde offerte n'est pas un achat
      return q;
    }
    const lineOf = (v, md) => (cart.items || []).filter((it) => isLine(it, v, md)).pop();

    function zone(c) {
      const { p, v, md } = cur(c);
      const z = $('[data-zone]', c);
      const q = qOf(v, md);
      const elig = !CFG || isElig(p.pid) || p.pid === CFG.giftProduct;
      if (!q) {
        z.innerHTML = '<button type="button" class="dd-oc__add" data-a="add"' + (v.av ? '' : ' disabled') + '>' + (!v.av ? 'Épuisé' : md === 'sub' ? 'M’abonner · −' + v.pct + ' %' : 'Ajouter au panier') + (v.av ? ' <span aria-hidden="true">+</span>' : '') + '</button>' +
          (md === 'one' && !elig ? '<p class="dd-oc__x">Hors offre gourde</p>' : '');
        return;
      }
      let prog = '';
      if (md === 'sub') prog = '<div class="dd-oc__prog ok">' + ICON.check + '<span>Abonnement −' + v.pct + ' % appliqué · livré chaque mois, sans engagement</span></div>';
      else if (v.sp) prog = '<div class="dd-oc__prog">Abonnez-vous : <b>' + fmt((v.price - v.spp) * q) + ' d’économie</b> chaque mois · <a href="#" data-a="tosub">passer en abonnement</a></div>';
      else if (!elig) prog = '<p class="dd-oc__x">Hors offre gourde</p>';
      z.innerHTML = '<div class="dd-oc__qty"><div class="dd-oc__step"><button type="button" data-a="dec" aria-label="Retirer un">−</button><output aria-live="polite">' + q + '</output><button type="button" data-a="inc" aria-label="Ajouter un">+</button></div>' +
        '<div class="dd-oc__ql"><b>' + q + ' dans le panier</b><span>' + fmt(unit(v, md) * q) + (md === 'sub' ? ' / mois' : '') + ' · <a href="/cart" data-dd-open>Voir le panier</a></span></div></div>' + prog;
    }
    function paintCard(c) {
      const { p, v, md } = cur(c);
      const total = p.vars.reduce((s, x) => s + qOf(x, 'one') + qOf(x, 'sub'), 0);
      c.classList.toggle('is-on', total > 0);
      c.classList.toggle('is-sub', md === 'sub');
      const cnt = $('.dd-oc__count', c);
      if (cnt.textContent !== String(total)) { cnt.textContent = total; if (total > 0) bump(cnt); }
      const pe = $('[data-price]', c); if (pe) pe.textContent = fmt(v.price);
      const ce = $('[data-cmp]', c); if (ce) { ce.textContent = v.cmp > v.price ? fmt(v.cmp) : ''; }
      const se = $('[data-sprice]', c); if (se && v.sp) se.textContent = fmt(v.spp);
      $$('.dd-oc__pr', c).forEach((b) => { const on = b.dataset.mode === md; b.classList.toggle('is-act', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); if (b.dataset.mode === 'sub') b.hidden = !v.sp; });
      zone(c);
    }
    const paintAll = () => cards.forEach((c) => byPid[c.dataset.pid] && !(c._n > 0) && paintCard(c));

    // ajoute la gourde offerte si le seuil est atteint (achats à l'unité uniquement)
    function withGift(items, p, v, md, qty) {
      if (!CFG || md !== 'one' || !isElig(p.pid)) return false;
      const st = giftState(cart, [{ pid: p.pid, price: v.price, qty }]);
      if (st && st.ok && !st.giftIn) { items.push({ id: CFG.gift, quantity: 1 }); return true; }
      return false;
    }
    // retire la gourde ajoutée automatiquement si le seuil n'est plus atteint
    async function dropGift() {
      if (!CFG || !autoGift()) return null;
      const st = giftState(cart);
      if (!st || st.ok || !st.giftIn) return null;
      const g = (cart.items || []).filter((it) => it.variant_id === CFG.gift && !it.selling_plan_allocation).pop();
      memSet('ddGiftAuto', '0');
      if (!g) return null;
      const resp = await cartReq('/cart/change.js', { id: g.key, quantity: g.quantity - 1 });
      toast('Gourde offerte retirée · plus que <b>' + fmt(giftState(resp).left) + '</b> pour la récupérer', 3200);
      return resp;
    }
    async function refresh() { cart = await getCart(true); paintAll(); }

    async function act(c, a) {
      const { p, v, md } = cur(c);
      const q = qOf(v, md);
      if (a === 'add' || a === 'inc') {
        const items = [md === 'sub' ? { id: v.id, quantity: 1, selling_plan: v.sp } : { id: v.id, quantity: 1 }];
        let gift = withGift(items, p, v, md, 1), resp;
        try { resp = await cartReq('/cart/add.js', { items }); }
        catch (err) { if (!gift) throw err; items.pop(); gift = false; resp = await cartReq('/cart/add.js', { items }); }
        if (gift) memSet('ddGiftAuto', '1');
        await refresh();
        if (a === 'add' && !opened && openDrawer(resp)) opened = true;
        else { silentRender(resp, cart.item_count); bump(cartIcon()); if (a === 'add') toast((md === 'sub' ? '<b>Abonnement ajouté</b> · −' + v.pct + ' % chaque mois' : '<b>Ajouté au panier</b>') + ' · <a href="/cart" data-dd-open style="color:inherit;text-decoration:underline">Voir</a>'); }
        if (gift) setTimeout(() => celebrate($('.dd-oc__count', c), 'Gourde de 50 cl d’huile offerte ajoutée au panier'), 500);
      } else if (a === 'dec') {
        const line = lineOf(v, md); if (!line) return;
        let resp = await cartReq('/cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity - 1) });
        cart = resp;
        resp = (await dropGift()) || resp;
        cart = resp;
        silentRender(resp, resp.item_count);
        paintAll();
      } else if (a === 'tosub') {
        const line = lineOf(v, 'one'); if (!line || !v.sp) return;
        const n = q || line.quantity;
        await cartReq('/cart/add.js', { items: [{ id: v.id, quantity: n, selling_plan: v.sp }] });
        const resp = await cartReq('/cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity - n) });
        mode[p.pid] = 'sub';
        cart = resp;
        const g = await dropGift();
        if (g) cart = g;
        silentRender(cart, cart.item_count);
        paintAll();
        toast('<b>Abonnement activé</b> · −' + v.pct + ' % chaque mois, sans engagement');
      }
    }

    root.addEventListener('click', (e) => {
      const t = e.target.closest('button, a[data-a]'); if (!t) return;
      const c = t.closest('.dd-oc'); if (!c || !byPid[c.dataset.pid]) return;
      if (t.classList.contains('dd-oc__var')) {
        const p = byPid[c.dataset.pid];
        chosen[p.pid] = Number(t.dataset.vid);
        $$('.dd-oc__var', c).forEach((x) => { const on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
        paintCard(c); return;
      }
      if (t.classList.contains('dd-oc__pr')) {
        const p = byPid[c.dataset.pid], md = t.dataset.mode;
        if (md === 'sub' && !cur(c).v.sp) return;
        if ((mode[p.pid] || 'one') !== md) { mode[p.pid] = md; vib(6); paintCard(c); }
        return;
      }
      const a = t.dataset.a; if (!a) return;
      if (t.tagName === 'A') e.preventDefault();
      if (a === 'add' && c._n > 0) return;
      // retour immédiat
      vib(a === 'dec' ? 5 : 8);
      if (a === 'add' || a === 'inc') fly($('.dd-oc__media img', c)).catch(() => {});
      const out = $('output', c);
      if (out && (a === 'inc' || a === 'dec')) out.textContent = Math.max(0, (+out.textContent || 0) + (a === 'inc' ? 1 : -1));
      if (a === 'add') t.classList.add('is-loading');
      c._n = (c._n || 0) + 1;
      c.classList.add('is-busy');
      queue = queue.then(() => act(c, a)).catch((err) => { toast(err.message || 'Une erreur est survenue'); return refresh().catch(() => {}); })
        .then(() => { c._n--; if (!c._n) { c.classList.remove('is-busy'); paintCard(c); } });
    });

    paintAll();
    getCart(true).then((c) => { cart = c; if (CFG && autoGift() && !(c.items || []).some((it) => it.variant_id === CFG.gift)) memSet('ddGiftAuto', '0'); paintAll(); }).catch(() => {});
    root._ddRefresh = async () => { if (root.querySelector('.dd-oc.is-busy')) return; cart = await getCart(true); paintAll(); };
  }

  /* ---------- fiche produit : choix unité / abonnement ---------- */
  function subBoxes() {
    $$('[data-dd-sub]').forEach((box) => {
      let map = {};
      try { map = JSON.parse($('script[data-sub]', box).textContent); } catch (e) { return; }
      const sec = box.closest('section, .shopify-section') || document;
      const form = $('product-form form[action*="/cart/add"]', sec) || $('form[action*="/cart/add"][id^="product-form-"]:not([id*="installment"])', sec);
      if (!form) return;
      let input = form.querySelector('input[name="selling_plan"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'selling_plan'; input.value = ''; form.appendChild(input); }
      let md = 'one';
      const vidOf = () => { const i = form.querySelector('input[name="id"]'); return i ? i.value : ''; };
      const paint = () => {
        const v = map[vidOf()] || null;
        const can = !!(v && v.sp);
        if (!can) md = 'one';
        box.hidden = !can;
        if (v) {
          const pe = $('[data-price]', box); if (pe) pe.textContent = fmt(v.price);
          const se = $('[data-sprice]', box); if (se && v.sp) se.textContent = fmt(v.spp);
          const pc = $('[data-pct]', box); if (pc) pc.textContent = v.pct;
        }
        input.value = md === 'sub' && can ? v.sp : '';
        $$('.dd-oc__pr', box).forEach((b) => { const on = b.dataset.mode === md; b.classList.toggle('is-act', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        box.classList.toggle('is-sub', md === 'sub');
        const sb = $('[name="add"] span', form) || $('[name="add"]', form);
        if (sb && !sb.dataset.ddLbl) sb.dataset.ddLbl = sb.textContent.trim();
        if (sb && sb.dataset.ddLbl && !$('[name="add"]', form).disabled) sb.textContent = md === 'sub' && can ? 'M’abonner · −' + v.pct + ' %' : sb.dataset.ddLbl;
      };
      box.addEventListener('click', (e) => { const b = e.target.closest('.dd-oc__pr'); if (!b) return; md = b.dataset.mode; vib(6); paint(); });
      form.addEventListener('change', () => setTimeout(paint, 30));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(paint, 60));
      paint();
    });
  }

  /* ---------- init ---------- */
  function anchors() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('a[href*="#commander"]');
      if (!a) return;
      const t = document.getElementById('commander');
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    });
  }
  function init() {
    anchors();
    hero();
    reveal();
    marquees();
    magnetic();
    counters();
    hookProductForms();
    $$('.dd-order').forEach(orderModule);
    subBoxes();
    if (CFG) {
      if (memGet('ddGiftOk') === null) getCart(true).then((c) => { const s = giftState(c); memSet('ddGiftOk', s && s.ok ? '1' : '0'); refreshCartBars(); }).catch(() => {});
      else refreshCartBars(true);
      watchDrawer();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          cartCache = null;
          bump(cartIcon());
          setTimeout(() => { refreshCartBars(true); $$('.dd-order').forEach((r) => r._ddRefresh && r._ddRefresh()); }, 60);
        });
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
